import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Button } from '@chatterbug/aaron'

import routes from 'src/lib/rails-routes/rails-routes'
import ActionsList from 'src/ui/Action/ActionsList'
import Action from 'src/ui/Action/Action'
import CoachMark from 'src/ui/CoachMark/CoachMark'
import { usePageParams } from 'src/utils/params'
import { t } from 'src/lib/i18n-react'

const SPOTLIGHT_SX = {
  // add some vertical padding
  // use `px`
  marginTop: '-8px',
  paddingTop: '8px',
  paddingBottom: '8px',
  boxSizing: 'content-box',
}

const Actions = ({ showEdit, onClick }) => {
  const { l2Code } = usePageParams()

  return (
    <CoachMark
      name="coach_mark:edit_my_course"
      title={t('Change up your Learning')}
      description={t('Reorder, add and remove units at any time.')}
      align="below"
      spotlightSx={SPOTLIGHT_SX}
    >
      <ActionsList>
        {showEdit && (
          <Action onClick={onClick} separator>
            {t('Edit')}
          </Action>
        )}
        <Action href={routes.advanced_topics(l2Code)}>{t('Add topics')}</Action>
      </ActionsList>
    </CoachMark>
  )
}

Actions.propTypes = {
  showEdit: PropTypes.bool,
  onClick: PropTypes.func,
}

const CourseActions = ({
  courseListEmpty = false,
  isEditMode,
  onToggleEditMode,
}) => {
  const showEditLink = !courseListEmpty && !isEditMode
  const onClick = () => onToggleEditMode(!isEditMode)
  return (
    <Flex alignItems="center">
      {isEditMode ? (
        <Button type="primaryAdvanced" onClick={onClick}>
          {t('Done')}
        </Button>
      ) : (
        <Actions showEdit={showEditLink} onClick={onClick} />
      )}
    </Flex>
  )
}

CourseActions.propTypes = {
  courseListEmpty: PropTypes.bool,
  isEditMode: PropTypes.bool.isRequired,
  onToggleEditMode: PropTypes.func.isRequired,
}

export default CourseActions
